import { geocodeByAddress } from "react-places-autocomplete";

export type TAddress = {
  types?: string[];
  formatted_address?: string;
  location_type?: "ROOFTOP" | string;
  lat?: number;
  lng?: number;
  country?: string;
  area?: string;
  region?: string;
  locality?: string;
  postal_code?: string;
  route?: string;
  street_number?: string;
};

const convertGoogleResultsToAddress = (result: any) => {
  const address: TAddress = {
    types: result?.types ?? undefined,
    formatted_address: result?.formatted_address ?? undefined,
  };

  if (result.address_components && Array.isArray(result.address_components)) {
    result.address_components.forEach((ac: any) => {
      if (
        ac.types &&
        Array.isArray(ac.types) &&
        ac.types.includes("street_number")
      ) {
        address.street_number = ac.long_name;
      }
      if (ac.types && Array.isArray(ac.types) && ac.types.includes("route")) {
        address.route = ac.long_name;
      }
      if (
        ac.types &&
        Array.isArray(ac.types) &&
        ac.types.includes("locality")
      ) {
        address.locality = ac.long_name;
      }
      if (
        ac.types &&
        Array.isArray(ac.types) &&
        ac.types.includes("administrative_area_level_2")
      ) {
        address.region = ac.long_name;
      }
      if (
        ac.types &&
        Array.isArray(ac.types) &&
        ac.types.includes("administrative_area_level_1")
      ) {
        address.area = ac.long_name;
      }
      if (ac.types && Array.isArray(ac.types) && ac.types.includes("country")) {
        address.country = ac.long_name;
      }
      if (
        ac.types &&
        Array.isArray(ac.types) &&
        ac.types.includes("postal_code")
      ) {
        address.postal_code = ac.long_name;
      }
    });
  }

  if (result?.geometry?.location?.lat) {
    address.lat = result.geometry.location.lat();
  }
  if (result?.geometry?.location?.lng) {
    address.lng = result.geometry.location.lng();
  }

  return address;
};

export default function useAddressGeocoder() {
  const geocodeAddress = async (
    address: string,
    callback: (address: any) => void
  ) => {
    const results = await geocodeByAddress(address);

    const convertedAddress = convertGoogleResultsToAddress(results[0]);

    callback(convertedAddress);
  };

  return {
    geocodeAddress,
  };
}
